import React from 'react';
import DetailsModelTableWrapper from '../details-model-table-wrapper';
import DetailsModelTableRow from '../details-model-table-row';
import CalcBreakdownRows from './details-model-calc-breakdown';
import rowColors from './utils/details-model-colors';

const { rowColor1, rowColor2, rowColor3 } = rowColors;

const DiscountDetailsModalTable = ({
  type,
  calcBreakDown,
  tableData,
  multiplyOn,
  formData,
  hideDetails,
}) => {
  const { markupDetails, contingencyDetails, escalationDetails, taxDetails, discountDetails } =
    tableData;

  // Markup
  const { markupCost, totalAfterMarkup, totalMarkupPercentage } = markupDetails;

  // Contingency
  const { contingencyCost, totalAfterContingency, totalContingencyPercentage } = contingencyDetails;

  // Escalation
  const { escalationCost, totalAfterEscalation, totalEscalationPercentage } = escalationDetails;

  // Tax
  const { taxCost, totalAfterTax, totalTaxPercentage } = taxDetails;

  // Discount
  const {
    breakdownValues,
    discountPercentages,
    discountCost,
    totalAfterDiscount,
    totalDiscountPercentage,
  } = discountDetails;

  const selectedKeys = Object.entries(multiplyOn)
    .filter(([key, value]) => formData[key] && value === true)
    .map(([key]) => key.charAt(0).toUpperCase() + key.slice(1).toLowerCase());

  return (
    <DetailsModelTableWrapper
      type={type}
      subtotal={totalAfterDiscount[5].toFixed(2)}
      TotalCost={discountCost[5].toFixed(2)}
      tableData={tableData}
      hideDetails={hideDetails}
    >
      {[
        {
          title: 'Markup Cost',
          values: markupCost.map((item) => `$${item.toFixed(2)}`),
        },
        {
          title: 'Markup Percentage',
          values: totalMarkupPercentage.map((item) => `${item.toFixed(2)}%`),
        },
        {
          title: 'Cost With Markup',
          values: totalAfterMarkup.map((item) => `$${item.toFixed(2)}`),
          bgColor: rowColor3,
        },
        {
          title: `Contingency Cost`,
          values: contingencyCost.map((item) => `$${item.toFixed(2)}`),
        },
        {
          title: 'Contingency Percentage',
          values: totalContingencyPercentage.map((item) => `${item.toFixed(2)}%`),
        },
        {
          title: 'Cost With Contingency',
          values: totalAfterContingency.map((item) => `$${item.toFixed(2)}`),
          bgColor: rowColor3,
        },
        {
          title: 'Escalation Cost',
          values: escalationCost.map((item) => `$${item.toFixed(2)}`),
        },
        {
          title: 'Escalation Percentage',
          values: totalEscalationPercentage.map((item) => `${item.toFixed(2)}%`),
        },
        {
          title: 'Cost With Escalation',
          values: totalAfterEscalation.map((item) => `$${item.toFixed(2)}`),
          bgColor: rowColor3,
        },
        {
          title: `Tax Cost`,
          values: taxCost.map((item) => `$${item.toFixed(2)}`),
        },
        {
          title: 'Tax Percentage',
          values: totalTaxPercentage.map((item) => `${item.toFixed(2)}%`),
        },
        {
          title: 'Cost With Tax',
          values: totalAfterTax.map((item) => `$${item.toFixed(2)}`),
          bgColor: rowColor3,
        },

        {
          title: `Discount Cost ${
            selectedKeys.length > 0 ? `(Including ${selectedKeys.join(', ')} Cost)` : ''
          }`,
          values: discountCost.map((item) => `$${item.toFixed(2)}`),
        },
        {
          title: 'Discount Percentage',
          values: discountPercentages.map((item) => `${item.toFixed(2)}%`),
        },
        {
          title: 'Total Cost',
          values: totalAfterDiscount.map((item) => `$${item.toFixed(2)}`),
          boldValues: true,
        },

        {
          title: 'Total Percentage',
          values: totalDiscountPercentage.map((item) => `${item.toFixed(2)}%`),
          bgColor: rowColor1,
        },
      ].map((row, index) => (
        <DetailsModelTableRow
          key={index}
          title={row.title}
          description={row?.description || ''}
          values={row.values}
          bgColor={row?.bgColor || ''}
          boldValues={row?.boldValues || false}
          hideDetails={hideDetails}
        />
      ))}

      {calcBreakDown && (
        <CalcBreakdownRows
          breakdownValues={breakdownValues}
          title={`Total ${type} Cost`}
          costs={discountCost}
          hideDetails={hideDetails}
        />
      )}
    </DetailsModelTableWrapper>
  );
};

export default DiscountDetailsModalTable;
